import React from 'react';
import DynamicFormViewer from '../../Components/FormData/DynamicFormViewer';
import {
  getAllEnrollInHealthPackages,
  deleteEnrollInHealthPackage,
  updateEnrollInHealthPackageById,
} from '../../Redux/Store/API/FormsData/EnrollInHealthPackage';

export default function EnrolledHealthFormData() {
  const headers = [
    { key: 'firstname', label: 'First Name' },
    { key: 'lastname', label: 'Last Name' },
    { key: 'mobileNo', label: 'Mobile No' },
    { key: 'packageName', label: 'Package Name' },
    { key: 'city', label: 'City' },
    { key: 'state', label: 'State' },
    { key: 'gender', label: 'Gender' },
    { key: 'description', label: 'Description' },
    { key: 'sourcePage', label: 'Source Page', render: (v) => v || '—' },
  ];

  return (
    <DynamicFormViewer
      title="Enrolled Health Packages"
      headers={headers}
      fetchAction={getAllEnrollInHealthPackages}
      deleteAction={deleteEnrollInHealthPackage}
      updateAction={updateEnrollInHealthPackageById}
      stateSliceName="enrollInHealthPackage"
      dataKey="getallenrollInHealthPackages"
    />
  );
}